module.exports = __webpack_public_path__ + "120316d86001911ca318d627334d5074.svg";